import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import FaqList from "../components/FaqList";
import CTABand from "../components/CTABand";
import { FAQS, FAQ_CATEGORIES } from "../data/site";
import { breadcrumbSchema, faqSchema } from "../lib/schema";

const slug = (s) => s.toLowerCase().replace(/&/g, "and").replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "");

export default function Faq() {
  const crumbs = [
    { name: "Home", path: "/" },
    { name: "FAQ", path: "/faq" },
  ];
  return (
    <>
      <SEO
        title="Online Therapy FAQ | Telehealth Counseling in NJ"
        description="Answers about online therapy in New Jersey: finding a therapist, insurance coverage, anxiety, depression, teen and child therapy, couples, ADHD, and how to book."
        path="/faq"
        schema={[breadcrumbSchema(crumbs), faqSchema(FAQS)]}
      />
      <PageHero crumbs={crumbs} eyebrow="FAQ" title="Frequently asked"
        accent="questions"
        underline body="Everything you need to know about virtual therapy with NJ Therapy Online." testid="faq-hero" />
      <section className="section">
        <div className="container-site max-w-3xl">
          <nav aria-label="FAQ topics" className="flex flex-wrap gap-2" data-testid="faq-topics">
            {FAQ_CATEGORIES.map((c) => (
              <a key={c} href={`#${slug(c)}`} className="chip" data-testid={`faq-topic-${slug(c)}`}>{c}</a>
            ))}
          </nav>
          <div className="mt-10 space-y-12" data-testid="faq-page-list">
            {FAQ_CATEGORIES.map((c) => (
              <div key={c} id={slug(c)} className="scroll-mt-28">
                <h2 className="text-2xl md:text-3xl">{c}</h2>
                <div className="mt-4">
                  <FaqList faqs={FAQS.filter((f) => f.category === c)} testid={`faq-group-${slug(c)}`} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CTABand />
    </>
  );
}
